export default {
  home: 'Home',
};
